import { render } from "./user-info-detail.vue?vue&type=template&id=87182a02&scoped=true&ts=true"
import script from "./user-info-detail.vue?vue&type=script&lang=ts"
export * from "./user-info-detail.vue?vue&type=script&lang=ts"

import "./user-info-detail.vue?vue&type=style&index=0&id=87182a02&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87182a02"]])